import ZDialog from './dialog.vue'

const Dialog = {}

// 注册Dialog
Dialog.install = function(Vue) {
  // 生成一个Vue的子类
  // 同时这个子类也就是组件
  const DialogConstructor = Vue.extend(ZDialog)
  // 生成一个该子类的实例
  const instance = new DialogConstructor()

  // 将这个实例加入全局挂载点内部
  document.body.appendChild(instance.$mount().$el)

  const initOptions = {
    title: '',
    content: '',
    okText: '确定',
    cancelText: '取消',
    ok: () => false,
    mask: () => false,
    cancel: () => false
  }

  const dialog = (type, ops) => {
    const options = { ...initOptions, ...ops }

    Object.keys(options).forEach((key) => {
      if (!/^(ok|cancel|mask)$/.test(key)) {
        instance[key] = options[key]
      }
    })

    instance.type = type
    instance.open()

    if (options.ok) {
      instance.onOk = () => {
        const isPreventClose = options.ok()
        !isPreventClose && instance.close()
      }
    }

    if (options.mask) {
      instance.onMask = () => {
        const isPreventClose = options.mask()
        !isPreventClose && instance.close()
      }
    }

    if (type !== 'alert' && options.cancel) {
      instance.onCancel = () => {
        const isPreventClose = options.cancel()
        !isPreventClose && instance.close()
      }
    }
  }

  // 通过Vue的原型注册一个方法
  // 让所有实例共享这个方法
  Vue.prototype.$alert = (options) => dialog('alert', options)
  Vue.prototype.$confirm = (options) => dialog('confirm', options)
}

export default Dialog
